export const LINK_SEPARATOR = '/'
export const ROOT_IDENTIFIER = ''

type ChainLink = string
type ChainPath = string

type PathOrChain = ChainPath | StepTreePathChain

export class StepTreePathChain {
  path: ChainPath

  static parsePathOrChain = (pathOrChain: PathOrChain): ChainPath => {
    return pathOrChain instanceof StepTreePathChain
      ? pathOrChain.getPath() // I <3 PRETTIER
      : pathOrChain
  }

  constructor(pathOrChain?: PathOrChain) {
    if (pathOrChain === undefined) {
      this.path = ROOT_IDENTIFIER
      return
    }

    this.path = StepTreePathChain.parsePathOrChain(pathOrChain)
  }

  getPath = () => this.path

  getLastLink = () => this.path?.split(LINK_SEPARATOR).pop()

  attachNewLink = (uniqueLinkId: ChainLink) => {
    const newPath = `${this.path}${LINK_SEPARATOR}${uniqueLinkId}`
    return new StepTreePathChain(newPath)
  }

  isParentOf = (suspectedChild: PathOrChain) => {
    const suspectedChildPath = StepTreePathChain.parsePathOrChain(suspectedChild)
    return suspectedChildPath.startsWith(this.getPath())
  }

  isChildOf = (suspectedParent: PathOrChain) => {
    const suspectedParentPath = StepTreePathChain.parsePathOrChain(suspectedParent)
    return this.getPath().startsWith(suspectedParentPath)
  }

  containsLink = (link: ChainLink) => {
    const links = this.getPath().split(LINK_SEPARATOR)
    return links.includes(link)
  }
}
